export default [
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () => import("../../../views/pages/auth/resetpassword.vue"),
  },
];
